* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  --severity-color: var(--chart-300-icon-buttons);
  --text-color: var(--main-titles-inputs-600);
  --text-color-secondary: var(--body-text-arrows-400);
  --spacer-color: var(--chart-101-pressed-dividers);
  --spacer-text-color: var(--chart-302-icon-buttons-titles);
  --killChainStep-min-width: 127px;
}

.impact-container {
  display: flex;
  margin: calc(var(--spacer) - 1px) 0 calc(var(--spacer) + 1px) 0;

  gz-text {
    display: flex;
    width: auto;
    padding-right: var(--spacer);
    align-items: center;
    color: var(--chart-300-icon-buttons);
    .icon {
      display: flex;
      span.value {
        padding-left: calc(var(--spacer) / 2);
        font-family: var(--font-family-secondary-mono);
        font-size: var(--body-size);
        color: var(--body-text-arrows-400);
        display: flex;
        align-items: center;
      }
    }
  }
}

.timeline-item-container {
  padding-left: calc(var(--spacer) * 2 + 3px);
  padding-bottom: calc(var(--spacer) * 3 - 4px);
  margin-left: calc(var(--spacer) * 2 + 3px);
  border-left: 1px solid var(--chart-101-pressed-dividers);
  position: relative;

  &.icon {
    &:before {
      position: absolute;
      font-size: 40px;
      left: -20px;
      top: -8px;
      color: var(--severity-color);
      background: transparent;
    }
  }

  .timeline-item-inner {
    display: flex;
    flex-flow: column;
    padding-left: calc(var(--spacer) * 2);

    gz-link {
      --wrapper-padding: 0;
      font-size: var(--body-size-xsmall);
      line-height: calc(var(--spacer) * 2.25);
      text-transform: uppercase;
    }

    gz-link::part(container) {
      color: var(--chart-300-icon-buttons);

      &:hover {
        color: var(--blue-layout-300-active);
      }
    }
  }

  .secondary-title-element-container {
    display: grid;
    font-size: var(--body-size);
    margin-bottom: calc(var(--spacer) * 2);
    min-height: calc(var(--spacer) * 3);
    grid-template-columns: fit-content(100%) auto;
    align-content: center;

    gz-text[id='alertTitle'] {
      display: -webkit-box;
      color: var(--body-text-arrows-400);
      flex: 0.9;
      padding-right: calc(var(--spacer) / 2);
      word-break: break-all;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
    }

    gz-text[id='killChainStep'] {
      position: relative;
      padding-left: var(--spacer);
      min-width: var(--killChainStep-min-width);

      &:before {
        content: '';
        background-color: var(--spacer-color);
        position: absolute;

        width: 1px;
        height: 100%;
        left: 0;
      }

      color: var(--chart-300-icon-buttons);
      flex: 0.1;
    }
  }

  .severity-container {
    display: inline-flex;
    font-size: var(--body-size-xsmall);
    margin-bottom: var(--spacer);
    color: var(--chart-300-icon-buttons);

    .severity-label {
      flex: 1;
      line-height: 18px;
    }

    .severity-value {
      padding-left: var(--spacer);
      font-weight: 500;
      line-height: 18px;
    }
  }

  .sensor-container {
    font-size: var(--body-size-xsmall);
    display: inline-flex;
    color: var(--chart-300-icon-buttons);

    .sensor-label {
      display: inline;
      width: auto;

      span {
        font-style: italic;
      }
    }

    .sensor-value {
      display: inline;
      width: auto;
      padding-left: 5px;
    }
  }

  gz-text[id='alertDescription'] {
    font-size: var(--body-size);
    margin-bottom: calc(var(--spacer) / 2);
    color: var(--chart-300-icon-buttons);
    word-break: break-word;
  }
}
